import React from 'react';
import { useTranslation } from 'react-i18next';

const Experience = () => {
  const { t } = useTranslation();

  const jobs = [1, 2, 3].map((n) => ({
    n,
    period: t(`experience.job${n}Period`),
    type: t(`experience.job${n}Type`),
    role: t(`experience.job${n}Role`),
    company: t(`experience.job${n}Company`),
    desc: t(`experience.job${n}Desc`),
    stack: t(`experience.job${n}Stack`).split(',').map((s) => s.trim()),
  }));

  return (
    <section id="experience" className="bg-slatex-50 py-20 lg:py-28">
      <div className="container-x">
        <div className="max-w-2xl" data-aos="fade-up">
          <span className="eyebrow">{t('experience.eyebrow')}</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-ink">{t('experience.title')}</h2>
          <p className="mt-4 text-slatex-600">{t('experience.subtitle')}</p>
        </div>

        <ol className="relative mt-14 ml-3 border-l-2 border-slatex-200 lg:ml-4">
          {jobs.map((j, i) => (
            <li key={j.n} className="relative pb-10 pl-8 last:pb-0 lg:pl-12" data-aos="fade-up" data-aos-delay={i * 100}>
              <span className="absolute -left-[11px] top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-brand-700 ring-4 ring-white">
                <span className="h-1.5 w-1.5 rounded-full bg-white" />
              </span>

              <div className="rounded-2xl border border-slatex-200 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-card lg:p-7">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="text-sm font-semibold text-brand-600">{j.period}</span>
                  <span className="rounded-full bg-slatex-100 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-slatex-500">{j.type}</span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold text-ink font-display">{j.role}</h3>
                <p className="mt-0.5 text-sm font-semibold text-slatex-500">{j.company}</p>
                <p className="mt-3 text-sm leading-relaxed text-slatex-600">{j.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {j.stack.map((s) => (
                    <span key={s} className="rounded-full bg-brand-50 px-2.5 py-1 text-xs font-semibold text-brand-700">{s}</span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Experience;
